module.exports = __webpack_public_path__ + "static/arataki-itto-754515a563c9802ae55c26df7be50ef7.png";